import randomInt from '../randomInt';

/**
 * @private
 * Generates unique numbers given a range.
 *
 * @param {Number} count: total of numbers to generate
 * @param {Number} min: minimum value (inclusive)
 * @param {Number} max: maximum value (inclusive)
 * @param {Array} array: the collection of unique numbers generated
 */
function generator(count = 1, min = 1, max = 10, array) {
  let value;
  while (array.length < count) {
    value = randomInt(min, max);
    if (array.indexOf(value) === -1) {
      array.push(value);
    }
  }
}

/**
 * @public
 * Generates an array of unique numbers given a range.
 *
 * @see https://gist.github.com/jherax/602fb6e999e03e36233f95715d0891fb
 *
 * @param  {Number} count: how many numbers will be generated
 * @param  {Number} min: minimum positive value (inclusive)
 * @param  {Number} max: maximum positive value (inclusive)
 * @throws {RangeError} if parameters are negative values.
 * @return {Array} the collection of unique numbers generated
 */
export default function randomNumbers(count, min, max) {
  const uniqueNumbers = [];
  if (count < 0 || min < 0 || max < 0) {
    throw new RangeError('Parameters must be positive numbers');
  }
  generator(count, min, max, uniqueNumbers);
  return uniqueNumbers;
}
